export default "__VITE_ASSET__4ce7f729__"